/**
 * Editorial "V" watermark used behind every marketing section.
 * Sits absolute, non-interactive, extremely low opacity — pure texture.
 */
export default function VMark({
  className = "",
  size = 520,
  opacity = 0.05,
  position = "top-right",
}) {
  const positionClass =
    position === "top-right"
      ? "-top-24 -right-16"
      : position === "top-left"
      ? "-top-24 -left-16"
      : position === "bottom-left"
      ? "-bottom-24 -left-16"
      : position === "bottom-right"
      ? "-bottom-24 -right-16"
      : "top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2";

  return (
    <svg
      viewBox="0 0 200 240"
      className={`absolute pointer-events-none select-none ${positionClass} ${className}`}
      style={{ width: size, height: size * 1.2, color: `rgba(255,255,255,${opacity})` }}
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M0 0h40l60 180L160 0h40L115 240H85L0 0z" />
    </svg>
  );
}
